export const roundNumber = (value, decimalPlaces) => {
    const transformCons = Math.pow(10, decimalPlaces);
    return Math.round(value * transformCons) / transformCons;
};
//# sourceMappingURL=roundNumber.js.map